/** KDS Table Toolbar — composable toolbar above data tables (Figma node 995:33822). */

export const tableToolbarPaddingY = '16px';
export const tableToolbarGap = '8px';
export const tableToolbarDividerColor = 'neutral.100';

/** KDS Filter Chip — active filter pill (Figma node 995:33202). */

export const filterChipHeight = '32px';
export const filterChipPaddingX = '12px';
export const filterChipPaddingY = '8px';
export const filterChipGap = '4px';
export const filterChipBorderRadius = '99px';
export const filterChipCloseIconSize = 16;

/** KDS Filter Bar — active-filter strip below the toolbar (Figma node 995:33521). */

export const filterBarPaddingY = '12px';
export const filterBarChipGap = '8px';
export const filterBarSectionGap = '24px';
export const filterBarOuterGap = '12px';
